<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like in particular to acknowledge the dauntless Cunningham Geikie, whose book <em>The Holy Land and the Bible</em> was written during his travels through that land in the 1880s. Reading his account is like going there. He saw it and he described it—in intricate detail. To see it as he saw it is no longer possible, but to see it through his eyes is to see the land as it was in Bible times. As a companion volume to the Bible itself, his book, together with the illustrations made by his co-traveller H. A. Harper, is a portal into the past.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7fbceb98